






















































import Vue from 'vue';
import StatisticsBlock from '@/components/StatisticsBlock.vue';
import {EventApi} from '@/api/event-api';
import {EventStatistic} from '@/types/event-statistic';

export default Vue.extend({
  name: 'EventStatistics',
  props: ['eventId'],
  components: {StatisticsBlock},
  mounted() {
    EventApi.getStatistic(this.eventId).then(res => {
      this.statistics = res.data;
    });
  },
  data: () => ({
    statistics: new EventStatistic()
  }),
  computed: {
    totalToActiveTicket(): string {
      return (Number(this.statistics.ticketTotal) > 0 && Number(this.statistics.activeTicket) > 0
          ? Math.round(Number(this.statistics.activeTicket) / Number(this.statistics.ticketTotal) * 100)
          : 0) + ' %';
    },
    totalSessionTime(): string {
      return (Number(this.statistics.totalSessionTime) > 0
          ? Math.round(Number(this.statistics.totalSessionTime))
          : 0) + ' ч';
    }
  }
});
